{
  "Додому": "Home",
  "Бібліотека": "My library",
  "Завантаження": "loading",
  "Вхід": "Log in",
  "Реєстрація": "Sign up",
  "АБО": "OR",
  "Фільмотека": "Filmoteka",
  "Переглянуто": "Watched",
  "Черга": "Queue",
  "Розроблено": "Developed with",
  ".": "By",
  "Студентами GoIT": "GoIT Students",
  "Команда": "Team",
  "'IT-бджілки'": "'IT-bees'",
  "Олег Білас": "Oleg Bilas",
  "Тім-лід": "Team-lead",
  "Інна Шаваровська": "Inna Shavarovska",
  "Скрам-майстер": "Scrum-master",
  "Олександр Самарський": "Oleksandr Samarskyi",
  "Розробник": "Developer",
  "Шаді Абумутаір": "Shadi Abumutair",
  "Віка Работілова": "Vika Rabotilova",
  "Владислав Шостак": "Vlad Shostak",
  "Євген Чабан": "Yevhen Chaban",
  "Віктор Дубровець": "Viktor Dubrovets",
  "Наталія Румянцева": "Nataliia Rumiantseva",
  "Іван Тищенко": "Ivan Tishchenko",
  "Голос / Голосів": "Vote / Votes",
  "Популярність": "Popularity",
  "Оригінальна назва": "Original Title",
  "Жанр": "Genre",
  "Опис": "About"
}
